/** @format */

import React, { memo, Suspense } from "react";
import { useLocale } from "../i18n/hooks";
import { Subject } from "../resources/types";

const SubjectIcon: React.FC<
  { subject: Subject } & React.SVGAttributes<SVGElement>
> = ({ subject, ...props }) => {
  const locale = useLocale();

  const resolveSubjectId = (subjectId: string) => {
    let _subjectId = subjectId;

    switch (_subjectId) {
      case "mathematics-and-numeracy":
      case "maths":
        _subjectId = "mathematics";
        break;
    }

    return _subjectId;
  };

  const Icon = React.lazy(() =>
    import(`../../assets/icons/subjects/${resolveSubjectId(subject.id)}`).catch(
      (err) => import(`../../assets/icons/subjects/english-literature`),
    ),
  );

  return (
    <Suspense
      fallback={
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"></svg>
      }
    >
      <Icon title={subject.title[locale]} />
    </Suspense>
  );
};

export default memo(SubjectIcon);
